import React, { ReactNode } from 'react';
import { tuple, StyledProps } from '../_utils';

export const FormLayouts = tuple('vertical', 'horizontal');
export type FormLayout = typeof FormLayouts[number];

export interface FormProps {
  /** 表单布局 @default vertical */
  layout?: FormLayout;
  style?: React.CSSProperties;
  className?: string;
  /** 是否为纯展示的表单 */
  readOnly?: boolean;
  children?: ReactNode;
  /** item之间是否有分割线 */
  split?: boolean;
}

export const StatusTypes = tuple('success', 'error');
export type StatusType = typeof StatusTypes[number];

export interface FormItemProps {
  htmlFor?: string;
  label?: React.ReactNode;
  status?: StatusType;
  required?: boolean;
  message?: React.ReactNode;
  airlabel?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  className?: string;
  children?: ReactNode;
  onClick?: (args: FormItemProps) => void;
  active?: boolean;
}
